$(document).ready(function(){
  $('.oi-custom-info-cards-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: false,
    dots: false,
    swipe: true,      
    touchMove: true, 
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });
});